import useApi from "../../../hooks/useAPI"
import { useSelector } from "react-redux"
import { APIURL } from "../../../Constantes"
import { formatDinero } from "../../../utils/formatDinero"
import { Alert } from "@material-ui/lab"
import Avance from "../../../global/Avance"
import UserImage from "../../../global/UserImage"
import { Tooltip } from "@material-ui/core"
import EventAvailableIcon from "@material-ui/icons/EventAvailable"
import EventBusyIcon from "@material-ui/icons/EventBusy"
const TarjetaGrupo = (props) => {
    const { referencia = "", nombre = "", avance = 0, total = 0, ahorro = 0, srcSocial = "", src = "", moneda = "", alCorriente = false } = props
    return (
        <div style={{ boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', padding: "1rem", margin: "1rem 0" }}>
            <div>
                <UserImage Src={src} SrcSocial={srcSocial} />
            </div>
            <h3>Nombre: {nombre}</h3>
            <h3>Referencia: {referencia}</h3>
            <div style={{ margin: "0 0 10px 0", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "0.4rem" }}>
                <Tooltip title={(alCorriente) ? `Al Corriente` : 'Con Atraso'}>
                    {
                        alCorriente ? <EventAvailableIcon color="secondary" /> : <EventBusyIcon color="error" />
                    }
                </Tooltip>
                {(alCorriente) ? `Al Corriente` : "Con Atraso"}
            </div>
            <p>Monto paquete: {formatDinero(total)} {moneda}</p>
            <p>Ahorro: {formatDinero(ahorro)} {moneda}</p>
            <Avance progress={avance} />
            {/* <Divider style={{ backgroundColor: "rgb(0, 155, 219)", height: "3px", margin: "1rem 0" }} /> */}
        </div>
    )
}
const VGrupos = () => {
    const { cliente, referencia } = useSelector(store => store.cliente)
    const grupo = useApi(`Trip/Group/BO/${cliente.Grupo?.Id_Grupo}`)
    
    console.log("🚀 ~ file: index.jsx:38 ~ VGrupos ~ grupo:", grupo)

    if (!referencia) return (
        <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
    )

    if (grupo) return (
        <div style={{ margin: "1rem" }}>
            {
                (grupo.Participantes) ?
                    grupo.Participantes?.map((participante, index) =>
                        <TarjetaGrupo
                            key={index}
                            nombre={`${participante.Nombres} ${participante.ApellidoPaterno}`}
                            referencia={participante.Meta?.Referencia}
                            alCorriente={participante.Meta?.Paquete?.AlCorriente}
                            avance={participante.Avance}
                            total={participante.Meta?.Paquete?.Monto_Paquete}
                            ahorro={participante.Total}
                            srcSocial={participante.UserFotoSocial}
                            src={(participante.NombreFoto) ? `${APIURL}/User/photo/${participante.UserId}/${participante.NombreFoto.split(".")[0]}/${participante.NombreFoto.split(".")[1]}` : ""}
                            moneda={grupo.Moneda.Clave}
                        />
                    )
                    :
                    <Alert className="alerta" severity="info">No pertenece a ningún grupo</Alert>
            }
        </div>
    )
    return (
        <Alert className="alerta" severity="info">Referencia sin grupo</Alert>
    )
}
export default VGrupos